import UibookCase from 'uibook/case'
import React from 'react'
import TelegramBadge from '../TelegramBadge'

const I18N = {
  ru: {
    unread: 'Непрочитанные',
    muted: 'Muted статус',
    dark: 'Dark тема',
    hintUnread: 'Бейдж для непрочитанных уведомлений.',
    hintMuted: 'Спокойный индикатор muted состояния.',
    hintDark: 'Контрастная версия для dark темы.',
  },
  en: {
    unread: 'Unread',
    muted: 'Muted status',
    dark: 'Dark theme',
    hintUnread: 'Unread notifications counter.',
    hintMuted: 'Calm muted status indicator.',
    hintDark: 'High-contrast option on dark theme.',
  }
}

export default {
  background: 'dark',
  component: TelegramBadge,
  i18n: true,
  cases: [
    locale => <UibookCase props={{ type: 'number', mode: 'primary', large: true, value: '128', label: I18N[locale].unread, description: I18N.en.hintUnread }}></UibookCase>,
    locale => <UibookCase props={{ type: 'dot', mode: 'gray', label: I18N[locale].muted, description: I18N.en.hintMuted }}></UibookCase>,
    locale => <UibookCase props={{ type: 'number', mode: 'white', value: '7', label: I18N[locale].dark, description: I18N.en.hintDark }}></UibookCase>
  ]
}
